import React from 'react';
import Button from '@jobseeker/lotus/elements/Button';
import {Box} from '@jobseeker/lotus/foundations';
import {SxProps, Theme, Typography} from '@mui/material';
import {FcGoogle} from 'react-icons/fc';

type GoogleButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  text?: string;
  sx?: SxProps<Theme>;
};

const GoogleButton: React.FC<GoogleButtonProps> = ({
  onClick,
  disabled,
  text = 'Continue with Google',
  sx,
}) => {
  return (
    <Button
      variant="outlined"
      onClick={onClick}
      disabled={disabled}
      sx={sx as any}
    >
      <Box sx={{display: 'flex', alignItems: 'center', gap: '10px'}}>
        <FcGoogle size={20} />
        <Typography style={{color: '#111111'}}>{text}</Typography>
      </Box>
    </Button>
  );
};

export default GoogleButton;
